import React from "react";
import { isMobile } from "react-device-detect";
import { ReactSortable } from "react-sortablejs";
import { useTranslation } from "react-i18next";
import {Empty} from "antd";
import { SVG_DRAGDROP } from "svg/SVGs"
import AppTag from "components/ui/AppTag";


const ModifierGroupSingleView = ({ mod, actionButtons }) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-12 items-center border-b p-2 md:p-4 text-16px hover:bg-gray-100 cursor-pointer gap-2">
  
    {/* Drag icon */}
    <div className="col-span-1 flex items-center">
      <div className="w-5 h-5 cursor-move">
        <SVG_DRAGDROP />
      </div>
    </div>
  
    {/* Name (MAIN — takes more space) */}
    <h3 className="col-span-4 text-14px truncate" style={{ marginBottom: "0px" }}>
      {mod?.baseLanguage?.name}
    </h3>
  
    {/* Max Order Qty */}
    <div className="col-span-3 text-14px">
      <span className="font-medium">{t("Max Allowed Selection")}:</span>{" "}
      {mod?.maximumAllowedSelection}
    </div>
  
    {/* Price */}
    <div className="col-span-3 text-14px flex gap-1 items-center">
     <span className="font-medium">{t("Required")}:</span>{" "}
     <AppTag
            variant={mod?.isRequired ? "warning" : "neutral"}
            size="sm"
          >
            {mod?.isRequired ? t("Yes") : t("No")}
          </AppTag>
    </div>
  
    {/* Actions */}
    <div className="col-span-1 flex justify-end">
      {actionButtons(mod)}
    </div>
  
  </div>
  );
};

const ModifierGroupDragger = ({
  customizations,
  reOrderCategory,
  actionButtons=()=>{},
  mode="edit",
}) => {
  const { t } = useTranslation();

  return (
    <>
      {customizations && customizations?.length >= 1 ? (
        (isMobile || mode !== "edit" )? (
          <>
            {customizations &&
              customizations?.map((cat, index) => {
                return (
                  <ModifierGroupSingleView
                    mod={cat}
                    key={cat._id}
                    actionButtons={actionButtons}
                  />
                );
              })}
          </>
        ) : (
          <ReactSortable
            list={customizations}
            setList={() => {}}
            animation={300}
            onUpdate={(order) => {
                // console.log(order);
              reOrderCategory(order);
            }}
          >
            {customizations &&
              customizations?.map((cat, index) => {
                return (
                  <ModifierGroupSingleView
                    mod={cat}
                    key={cat._id}
                    actionButtons={actionButtons}
                  />
                );
              })}
          </ReactSortable>
        )
      ) : (
        <div className="flex justify-center w-full">
          <Empty
            description={<span>{t("There is no modifier attached")}</span>}
          />
        </div>
      )}
    </>
  );
}

export default ModifierGroupDragger;
